import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
messages: [],
};

export const aiChatSlice = createSlice({
  name: "ai-messages",
  initialState,
  reducers: {
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
  },
});

export const { setMessages } = aiChatSlice.actions;
export default aiChatSlice.reducer;
